module.exports = __webpack_public_path__ + "media/images/article/2022_03_a-b5a75cedc57edec6d9332f12588202b3.png";